import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllUsers = (keywords, role, limit, lastTime, callback) => {
  return async (dispatch) => {
    if (lastTime) {
      dispatch({
        type: 'GET_ALL_USERS_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'GET_ALL_USERS' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(`/ads/users/search`, keywords, {
            params: {
              'request-id': reqId,
              limit: limit,
              lastSeen: lastTime,
              role: role,
              usedConversation: false,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            if (lastTime) {
              await dispatch({
                type: 'ADD_USERS_TO_ALL_USERS',
                payload: {
                  users: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            } else {
              await dispatch({
                type: 'GET_ALL_USERS_DONE',
                payload: {
                  users: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GET_ALL_USERS_FAILED',
              payload: `Failed to fetch users`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GET_ALL_USERS_FAILED',
            payload: `Failed to fetch users`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GET_ALL_USERS_FAILED',
        payload: `Failed to fetch users`,
      });
    }
  };
};

export default getAllUsers;
